import { getChestApiUrl } from '../../helpers/index';
import { getHeaders } from '../helpers';

const get = ({ filters = {}, order = "price:asc", page = 0, size = 18, session = "", withInbound = false }) => {
  try {
    if (session) {
      let resultNum = 0;

      if (page !== 0)
        resultNum = page * size;

      const filterParams = Object.keys(filters).reduce((total, currentKey) => {
        if (filters[currentKey] !== undefined) total += `&${currentKey}=${filters[currentKey]}`;
        return total;
      }, '');

      const params = `s=${session}&withInbound=${withInbound}&sort=${order}&from=${resultNum}${filterParams}`;
      const url = `${getChestApiUrl()}/chestApi/flights/results?${params}`;

      return fetch(url)
        .then(r => r.json())
        .catch(err => console.error("[ERROR]:", err));
    } else {
      throw new Error(' NO SESSION AVALIABLE ');
    }
  } catch (err) {
    throw err;
  }
}


const update = ({ session }) => {
  try {
    return fetch(`${getChestApiUrl()}/chestApi/f/results/update`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ session })
    })
      .then(r => r.json())
      .then(res => !res.error);
  } catch (err) {
    throw err;
  }
}


export default {
  get,
  update
}